import { ResumeSkills } from "lib/redux/types";
import React from "react";
import { TemplateNineResumeSection } from "./common";
import { ResumePDFSkillsTwoColumn } from "../ResumePDF/common";
import { View } from "@react-pdf/renderer";
import { styles } from "../ResumePDF/styles";

const Skills = ({
  heading,
  skills,
  themeColor,
  showBulletPoints,
}: {
  heading: string;
  skills: ResumeSkills;
  themeColor: string;
  showBulletPoints: boolean;
}) => {
  const { descriptions } = skills;
  return (
    <TemplateNineResumeSection themeColor={themeColor} heading={heading}>
      <View wrap={false} style={{ ...styles.flexCol }}>
        <ResumePDFSkillsTwoColumn items={descriptions} />
      </View>
    </TemplateNineResumeSection>
  );
};

export default Skills;
